import { render } from "./MenuBreakdownTable.vue?vue&type=template&id=ec4da1ac"
import script from "./MenuBreakdownTable.vue?vue&type=script&lang=js"
export * from "./MenuBreakdownTable.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__